export default class Role {
  id: string;

  name: string;

  constructor(obj: any) {
    this.id = obj.id || null;
    this.name = obj.name || null;
  }

  public static of(obj: any): Role {
    return new Role(obj || {});
  }

  public static ofList(obj: any[]): Role[] {
    return obj.map(this.of);
  }
}
